import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Messages } from "../../_locale/locale.en";
import moment from 'moment';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';
import { withStyles } from '@material-ui/styles';
import { ChevronLeftIcon, ChevronRightIcon } from '../../_utils/icons.js';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { styles } from './Participation.styles';
import { theme } from '../../layout/Layout.theme';
import Paper from '@material-ui/core/Paper';
import clsx from 'clsx';
import * as SELECTORS from '../../../redux/Redux.selectors';
import { setDisplayedWeek, setAttendance, setSelectedDevotionalGroup } from '../../../redux/Redux.actions';
import { TIME } from '../../_utils/constants';
import { AGREEMENT_VALUES } from "./_constants";

const mapStateToProps = state => {
  return ({
    devotionalGroups: SELECTORS.devotionalGroupsSelector(state),
    members: SELECTORS.membersSelector(state),
    eventsInWeek: SELECTORS.eventsInWeekSelector(state),
    devotees: SELECTORS.devoteesSelector(state),
    displayedWeek: SELECTORS.displayedWeekSelector(state),
    membersEventAttendances: SELECTORS.membersEventAttendancesSelector(state),
    selectedDevotionalGroup: SELECTORS.selectedDevotionalGroupSelector(state),
    selectedDevotionalGroupId: SELECTORS.selectedDevotionalGroupIdSelector(state),
    devotionalGroupsForLeader: SELECTORS.devotionalGroupsForLeaderSelector(state),
  });
};

const mapDispatchToProps = dispatch => ({
  setDisplayedWeek: val => dispatch(setDisplayedWeek(val)),
  setAttendance: val => dispatch(setAttendance(val)),
  dispatchSetSelectedDevotionalGroup: val => dispatch(setSelectedDevotionalGroup(val)),
});

class ParticipationWeekly extends Component {
  handleJumpBackWeek() {
    const { displayedWeek } = this.props;
    // TODO: add more seed data for 2019
    const isAfter = moment(displayedWeek).isAfter("2019-06-10T07:00:00.000Z");
    isAfter &&
      this.props.setDisplayedWeek(moment(displayedWeek)
        .subtract(TIME.DAYS_IN_WEEK, 'days')
        .toDate().toISOString());
  }

  handleJumpForwardWeek() {
    const { displayedWeek } = this.props;
    // TODO: Dynamically Add more data
    const isBefore = moment(displayedWeek).isBefore("2020-01-01T07:00:00.000Z");
    isBefore &&
      this.props.setDisplayedWeek(moment(displayedWeek)
        .add(TIME.DAYS_IN_WEEK, 'days')
        .toDate().toISOString());
  }

  handleAttendanceChange(e, eventId, devoteeId, attendance) {
    const { value } = e.target;
    const attended = {
      attended: value === AGREEMENT_VALUES.YES,
      eventAgreement: {
        description: '',
        hasAgreement: value === AGREEMENT_VALUES.AGREEMENT,

      },
    };
    value && this.props.setAttendance({ attended, eventId, devoteeId, attendance });
    // If the user is resetting attendance to be unknown, pass in a falsy value for attended
    !value && this.props.setAttendance({ attended: value, eventId, devoteeId, attendance });
  }

  getAttendance(attendance) {
    let label;
    if (!attendance) {
      label = '';
    } else if (attendance.attended) {
      label = AGREEMENT_VALUES.YES;
    } else {
      label = attendance.eventAgreement.hasAgreement ?
        AGREEMENT_VALUES.AGREEMENT : AGREEMENT_VALUES.NO;
    }
    return label;
  }

  render () {
    const {
      classes,
      eventsInWeek,
      members,
      devotees,
      devotionalGroupsForLeader,
      membersEventAttendances,
      selectedDevotionalGroup,
      selectedDevotionalGroupId,
    } = this.props;

    const title = moment(_.get(eventsInWeek, `[0].startingOn`)).format('dddd, MMMM Do YYYY');
    const leaderName = selectedDevotionalGroup.groupLeader;

    return (
      <div className={clsx(classes.weekly)}>
        <Paper className={classes.paper}>
          <Typography variant={'h5'}>{`Devotional Group Leader: ${leaderName}`}</Typography>
          {devotionalGroupsForLeader.length > 1 &&
            <div>
              <Typography style={{ display: 'inline-block' }} variant={'body1'}>{`Select Group:`}</Typography>
              <Select
                  className={classes.selectContainer}
                  value={selectedDevotionalGroupId}
                  displayEmpty
                  onChange={e => this.props.dispatchSetSelectedDevotionalGroup(e.target.value)}
                  style={{
                    height: '40px',
                    width: '200px',
                  }}
                >
                  {devotionalGroupsForLeader.map((group, i) => {
                    return <MenuItem
                      key={i}
                      className={classes.selectOption}
                      value={group.id}>
                      {group.groupName}
                    </MenuItem>
                  })}
                </Select>
            </div>
          }
          <div
            // The header of the paper view
            className={classes.paperHeaderRow}
          >
            <ChevronLeftIcon
              fontSize={'large'}
              color={'primary'}
              onClick={() => this.handleJumpBackWeek()}
            />
              <Typography variant={'h5'}>{`Week starting: ${title}`}</Typography>
            <ChevronRightIcon
              fontSize={'large'}
              color={'primary'}
              onClick={() => this.handleJumpForwardWeek()}
            />
          </div>

          <div
            // row that contains all columns
            className={classes.attendanceContainer}
          >
            <div
              // The devotee name column
              className={classes.attendanceColumns}
            >
              <div className={classes.attendanceHeader}>Devotee Name</div>
              {members.map((member, i) => {
                const fullName = _.get(devotees, [member.devotee.id, 'fullName'], '');
                return (
                <div key={i} className={classes.attendanceCell}>{fullName}</div>
              )})}
            </div>

            {eventsInWeek.map(({ eventType, startingOn, id: eventId }, i) => (
              <div
                // One column per events in the week
                key={i}
                className={classes.attendanceColumns}
              >
                <div
                  key={i}
                  className={classes.attendanceHeader}
                >
                  <div>{eventType}</div>
                  <div>{`(${moment(startingOn).format('MMMM Do YYYY')})`}</div>
                </div>
                {members.map((member, i) => {
                  const attendance = membersEventAttendances.find(attendance =>
                    attendance.attendee.id === member.devotee.id &&
                    attendance.event.id === eventId
                  );
                  const label = this.getAttendance(attendance);
                  const devoteeId = member.devotee.id;
                  // console.log('attendance in the map', eventId, devoteeId);
                  return (
                    <div key={i} className={classes.attendanceCell}>
                      <Select
                        key={i}
                        className={classes.selectContainer}
                        value={label}
                        displayEmpty
                        onChange={(e) =>
                          this.handleAttendanceChange(e, eventId, devoteeId, attendance)}
                      >
                        <MenuItem
                          className={classes.selectOption}
                          value="">
                          <em>-</em>
                        </MenuItem>
                        <MenuItem
                          className={classes.selectOption}
                          value={AGREEMENT_VALUES.NO}>
                            {Messages.Agreements.No}
                        </MenuItem>
                        <MenuItem
                          className={classes.selectOption}
                          value={AGREEMENT_VALUES.AGREEMENT}>
                            {Messages.Agreements.Agreement}
                        </MenuItem>
                        <MenuItem
                          className={classes.selectOption}
                          value={AGREEMENT_VALUES.YES}>
                            {Messages.Agreements.Yes}
                        </MenuItem>
                      </Select>
                    </div>
                  )
                })}
              </div>
            ))}
          </div>
        </Paper>
      </div>
    )
  }
}

export default compose(
    firestoreConnect(['devotees', 'events', 'devotionalGroups', 'attendances']),
    connect(mapStateToProps, mapDispatchToProps)
    )(
    withStyles(
      styles,
      {
        defaultTheme: theme,
        withTheme: true,
        name: 'layout',
      }
    )(ParticipationWeekly));
